import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { useStore } from '../../../store';
import { IServerErrorResponse } from '../../../types';

interface IProps {
    linkedAccountId: string;
    amount: number;
    onClearAccounts?: () => void;
}

interface IResponse {
    clearDate: string;
    firstTimeACHHoldDaysMessage?: string;
}
export const useGetArrivalDateForAddMoney = ({ onClearAccounts, onError }: {onClearAccounts?: () => void, onError?:(errMsg: string) => void}) => {
  const { customerId } = useStore(state => state.user);
  return useMutation(
    'GetArrivalDateForAddMoney',
    async ({ linkedAccountId, amount }: IProps) => {
      const res = await httpService.post(`${BASE_URL}/api/v2/user/${customerId}/ach/${linkedAccountId}/estimated`, { amount, businessAccount: true });
      return res.data as IResponse;
    },
    {
      onError: (e: IServerErrorResponse) => {
        const errMsg = e?.response?.data?.errors?.[0]?.message;
        const EXPIRED_LINKED_TOKEN_ERRORS = [4252, 4253, 4255];
        const errorCode = e?.response?.data?.errors?.[0]?.code;
        if (EXPIRED_LINKED_TOKEN_ERRORS.includes(errorCode)) {
          if (onClearAccounts) onClearAccounts();
        }
        if (onError && errMsg) onError(errMsg);
      },
    },
  );
};
